module.exports = __webpack_public_path__ + "static/logo-grey-1d03341413cd693c3a60e924d07f6641.svg";